import React, { useState, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';

export const ButtonVariant = {
  TEXT: 'text',
  OUTLINED: 'outlined',
  CONTAINED: 'contained',
};

const OpenModalButton = (props) => {
  const {
    children,
    modalTitle,
    buttonClass,
    onClose,
    onOpen,
    useHeader = true,
    useFooter,
    variant,
    onSecondaryAction,
    onPrimaryAction,
    secondaryActionDisabled,
    primaryActionDisabled,
    primaryActionTitle,
    secondaryActionTitle,
    modalSize = 'md',
    modalBody,
    modalClassName,
    isIconButton,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = useCallback(() => {
    setIsModalOpen(true);
    onOpen?.();
  }, [onOpen]);

  const handleModalClose = useCallback(() => {
    setIsModalOpen(false);
    onClose?.();
  }, [onClose]);

  const handlePrimaryAction = useCallback(() => {
    onPrimaryAction?.();
    setIsModalOpen(false);
    onClose?.();
  }, [onPrimaryAction, onClose]);

  const handleSecondaryAction = useCallback(() => {
    onSecondaryAction?.();
    setIsModalOpen(false);
    onClose?.();
  }, [onSecondaryAction, onClose]);

  return (
    <>
      {isIconButton === true ? (
        <IconButton className={buttonClass} onClick={handleModalOpen}>
          {children}
        </IconButton>
      ) : (
        <Button variant={variant} className={buttonClass} onClick={handleModalOpen}>
          {children}
        </Button>
      )}
      <Dialog
        className={modalClassName ?? ''}
        open={isModalOpen}
        onClose={handleModalClose}
        maxWidth={modalSize}
        fullWidth
      >
        {useHeader && <DialogTitle>{modalTitle}</DialogTitle>}
        <DialogContent>
          {React.isValidElement(modalBody) && !useFooter
            ? React.cloneElement(modalBody, { handleModalClose })
            : modalBody}
        </DialogContent>
        {useFooter && (
          <DialogActions>
            <Button
              color="secondary"
              variant={ButtonVariant.CONTAINED}
              disabled={secondaryActionDisabled ?? false}
              onClick={handleSecondaryAction}
            >
              {secondaryActionTitle}
            </Button>
            <Button
              color="primary"
              variant={ButtonVariant.CONTAINED}
              disabled={primaryActionDisabled ?? false}
              onClick={handlePrimaryAction}
            >
              {primaryActionTitle}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default OpenModalButton;
